/**
 * custom.js
 * Entry point for all shop-level JS customisations.
 * Loaded by layout/theme.liquid after theme.js.
 */

/* ─────────────────────────────────────────────────────────────
   FREE GIFT AUTO-ADD / AUTO-REMOVE
   ─────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  if (!window.xFreeGiftConfig || !window.xFreeGiftConfig.enabled) return;

  var cfg = window.xFreeGiftConfig;
  var isProcessing = false;
  var debounceTimer = null;

  /**
   * Find the gift line in cart items.
   * Matches on variant_id AND the hidden _isGift property to avoid
   * touching a legitimately purchased copy of the same product.
   */
  function giftLineIndex(items) {
    return items.findIndex(function (item) {
      return (
        item.variant_id === cfg.variantId &&
        item.properties &&
        item.properties['_isGift'] === 'true'
      );
    });
  }

  function getSections() {
    return Alpine.store('xCartHelper').getSectionsToRender().map(function (s) {
      return s.id;
    });
  }

  async function addGift() {
    window.updatingCart = true;
    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: cfg.variantId, quantity: 1, properties: { _isGift: 'true' } }],
          sections: getSections()
        })
      });
      if (res.ok) {
        var data = await res.json();
        // Re-render via the theme helper — does NOT dispatch eurus:cart:items-changed,
        // so our listener is never re-entered from our own cart write.
        Alpine.store('xCartHelper').reRenderSections(data.sections);
      }
    } catch (e) {
      console.error('[xFreeGift] add error:', e);
    } finally {
      window.updatingCart = false;
    }
  }

  async function removeGift(lineIndex) {
    window.updatingCart = true;
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          line: lineIndex + 1, // Cart API uses 1-based line numbers
          quantity: 0,
          sections: getSections()
        })
      });
      if (res.ok) {
        var data = await res.json();
        Alpine.store('xCartHelper').reRenderSections(data.sections);
      }
    } catch (e) {
      console.error('[xFreeGift] remove error:', e);
    } finally {
      window.updatingCart = false;
    }
  }

  async function evaluateGift() {
    if (isProcessing) return;
    isProcessing = true;
    try {
      await Alpine.store('xCartHelper').waitForCartUpdate();
      var cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' }
      }).then(function (r) { return r.json(); });

      var giftLine = giftLineIndex(cart.items);
      var thresholdMet = cart.total_price >= cfg.thresholdCents;

      if (thresholdMet && giftLine === -1) {
        await addGift();
      } else if (!thresholdMet && giftLine !== -1) {
        await removeGift(giftLine);
      }
    } catch (e) {
      console.error('[xFreeGift] evaluate error:', e);
    } finally {
      isProcessing = false;
    }
  }

  function scheduleEvaluate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(evaluateGift, 200);
  }

  document.addEventListener('alpine:init', function () {
    document.addEventListener('eurus:cart:items-changed', scheduleEvaluate);
  });
})();

/* ─────────────────────────────────────────────────────────────
   TRUSTBADGE — hide when cart drawer or mobile nav is open
   CSS pointer-events/visibility don't cross iframe boundaries,
   so we forcibly toggle display:none via JS.
   ─────────────────────────────────────────────────────────── */
(function () {
  function getTrustbadge() {
    return document.querySelector('[id^="trustbadge-container"]');
  }

  function syncTrustbadge() {
    var el = getTrustbadge();
    if (!el) return;
    var hidden =
      document.body.classList.contains('cart-drawer-open') ||
      document.body.classList.contains('mobile-nav-open');
    el.style.display = hidden ? 'none' : '';
  }

  var observer = new MutationObserver(syncTrustbadge);
  observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });

  // Also re-check once the widget loads (it may inject after page load).
  var domObserver = new MutationObserver(function () {
    if (getTrustbadge()) {
      syncTrustbadge();
    }
  });
  domObserver.observe(document.documentElement, { childList: true, subtree: true });
})();

/* ─────────────────────────────────────────────────────────────
   NEWSLETTER ANCHOR — keep #newsletter-anmeldung in view while
   the Klaviyo form-embed renders. The anchor is an empty marker
   div; the app block renders into its own container, and that
   late async render shifts page height, so the browser's native
   hash-scroll on load ends up at the wrong offset.
   Any user scroll input cancels the correction immediately.
   ─────────────────────────────────────────────────────────── */
(function () {
  if (window.location.hash !== '#newsletter-anmeldung') return;

  var target = document.getElementById('newsletter-anmeldung');
  if (!target) return;

  // Server-rendered but empty; Klaviyo fills it in later.
  var form = document.querySelector('.klaviyo-form-XBkVP2');
  if (!form) return;

  var observer;
  var settleTimer;

  function stop() {
    if (observer) observer.disconnect();
    clearTimeout(settleTimer);
    window.removeEventListener('wheel', onUserScroll);
    window.removeEventListener('touchstart', onUserScroll);
    window.removeEventListener('keydown', onUserScroll);
  }

  function onUserScroll() {
    stop();
  }

  function realign() {
    target.scrollIntoView();
    clearTimeout(settleTimer);
    settleTimer = setTimeout(stop, 500);
  }

  window.addEventListener('wheel', onUserScroll, { passive: true });
  window.addEventListener('touchstart', onUserScroll, { passive: true });
  window.addEventListener('keydown', onUserScroll);

  observer = new MutationObserver(realign);
  observer.observe(form, { childList: true, subtree: true });

  // Hard cap: never keep correcting past this point.
  setTimeout(stop, 4000);
})();
